import { IAction } from "src/store";
import { augmentReducer } from "src/store/utils";
import { AllOrgParentInitialState, AllOrgMetricsState } from "./types";
import { allOrgMetricsReducer, AllOrgParentConstants } from "./redux";

const initialState = {
  chartsDataPending: false,
};

export const parentAllOrgMetricsReducer = (
  state = initialState,
  { type, payload }: IAction<symbol, any>
): AllOrgParentInitialState => {
  switch (type) {
    case AllOrgParentConstants.get("FETCHING_ALL_ORG_DATA"):
      return { ...state, chartsDataPending: payload };
    default:
      return state;
  }
};

export const augmentedAllOrgMetricsReducer = augmentReducer<AllOrgMetricsState, IAction<symbol, any>>(
  parentAllOrgMetricsReducer
)({
  metrics: allOrgMetricsReducer,
});
